export default __webpack_public_path__ + "static/media/img4.79e6e634.png";